import {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from 'react';
import wallpaper1 from '../assets/wallpaper/image1.jpg';
import wallpaper2 from '../assets/wallpaper/image2.jpg';
import wallpaper3 from '../assets/wallpaper/image3.jpg';
import wallpaper4 from '../assets/wallpaper/image4.jpg';
import wallpaper5 from '../assets/wallpaper/image5.jpg';

export type WallpaperId = 'none' | 'wallpaper1' | 'wallpaper2' | 'wallpaper3' | 'wallpaper4' | 'wallpaper5';

export const WALLPAPERS: { id: WallpaperId; src: string }[] = [
  { id: 'wallpaper1', src: wallpaper1 },
  { id: 'wallpaper2', src: wallpaper2 },
  { id: 'wallpaper3', src: wallpaper3 },
  { id: 'wallpaper4', src: wallpaper4 },
  { id: 'wallpaper5', src: wallpaper5 },
];

interface WallpaperContextValue {
  wallpaper: WallpaperId;
  setWallpaper: (id: WallpaperId) => void;
}

const WallpaperContext = createContext<WallpaperContextValue | null>(null);

function getInitialWallpaper(): WallpaperId {
  const stored = localStorage.getItem('wallpaper');
  if (stored === 'none' || WALLPAPERS.some(w => w.id === stored)) return stored as WallpaperId;
  return 'none';
}

export function WallpaperProvider({ children }: { children: ReactNode }) {
  const [wallpaper, setWallpaper] = useState<WallpaperId>(getInitialWallpaper);

  useEffect(() => {
    localStorage.setItem('wallpaper', wallpaper);
  }, [wallpaper]);

  return (
    <WallpaperContext.Provider value={{ wallpaper, setWallpaper }}>
      {children}
    </WallpaperContext.Provider>
  );
}

export function useWallpaper(): WallpaperContextValue {
  const ctx = useContext(WallpaperContext);
  if (!ctx) throw new Error('useWallpaper must be used within a WallpaperProvider');
  return ctx;
}
